import { tenantTexts } from '../../mixins/tenantTexts'

export const childrenPaths = []

export default [
  {
    path: '/routines/',
    name: 'Exercises',
    alias: ['/activities'],
    meta: {
      title: tenantTexts.navigation.routines.title,
      menuTitle: tenantTexts.navigation.routines.menuTitle,
      icon: 'bhi-pulse',
      requiresAuth: true,
    },
    component: () => import('@/views/Exercises.vue'),
    children: childrenPaths,
  },
  {
    path: '/routines/routine/:id',
    name: 'Sequence',
    hidden: true,
    meta: {
      title: 'Routine',
      icon: 'bhi-pulse',
      requiresAuth: true,
    },
    component: () => import('@/views/exercises/Sequence.vue'),
  },
  {
    path: '/shared/',
    name: 'Smart Exercises',
    hidden: true,
    meta: {
      title: 'Shared by Keep Rising',
      icon: 'bhi-pulse',
      requiresAuth: true,
    },
    component: () => import('@/views/exercises/SmartExercises.vue'),
  },
  {
    path: '/import-routines/',
    name: 'Smart Routines',
    hidden: true,
    meta: {
      title: 'Import Routines',
      icon: 'bhi-pulse',
      requiresAuth: true,
    },
    component: () => import('@/views/exercises/SmartSequences.vue'),
  },
]
